// src/Lexapp/AppCard.jsx
import React from 'react';
import styles from './lexapp.module.css';

const AppCard = ({ app }) => {
  return (
    <div className={styles.lexCard_lexApp}>
      {/* Use iconUrl instead of thumbnailURL */}
      <img
        src={app.iconUrl}
        alt={app.name}
        className={styles.lexThumbnail_lexApp}
      />

      {/* Use name instead of title */}
      <h3>{app.name}</h3>

      {/* your description field */}
      <p>{app.description}</p>

      {/* if you support tags, read from app.tags; otherwise omit */}
      {app.tags?.length > 0 && (
        <div className={styles.lexTags_lexApp}>
          {app.tags.map((tag, idx) => (
            <span key={idx} className={styles.lexTag_lexApp}>
              {tag}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default AppCard;
